<!--首页-->
<template>

  <div class="box">
    <div class="top-box">
      <div class="title">{{row.name}}</div>
      <van-dropdown-menu>
        <van-dropdown-item v-model="params.start_id" :options="options" @change="startIdChange" >
          <!--<template #title>-->
            <!--<p class="dropdown-item-title" v-if="options.length>0">{{options[optionSelectedIndex].text}}</p>-->
            <!--<p class="dropdown-item-time">{{options[value].time}}</p>-->
          <!--</template>-->
          <!--<div v-for="(item,i) in options" :key="i" class="dropdown-item" @click="dropdownChange1(item)">-->
            <!--<p>{{item.title}}</p>-->
            <!--<p>{{item.time}}</p>-->
          <!--</div>-->
        </van-dropdown-item>
        <!--<van-dropdown-item v-model="value2"  >-->
          <!--<template #title>-->
            <!--<p class="dropdown-item-title">{{option2[value2].text}}</p>-->
            <!--<p class="dropdown-item-time">{{option2[value2].time}}</p>-->
          <!--</template>-->
          <!--<div v-for="(item,i) in option2" :key="i" class="dropdown-item" @click="dropdownChange2(item)">-->
            <!--<p>{{item.text}}</p>-->
            <!--<p>{{item.time}}</p>-->
          <!--</div>-->
        <!--</van-dropdown-item>-->
      </van-dropdown-menu>
    </div>
    <div style="height:2.5rem"></div>
    <van-search v-model="keywords" placeholder="搜索队伍" @input="onSearch" />
    <div class="step-box">
      <van-steps direction="vertical" :active="1000">
        <van-step v-for="(subject,i) in list" v-show="subject.show" :key="i">
          <p class="item-team-name"><em>{{i+1}}</em> {{subject.mingcheng}}</p>
          <p class='item-team-desc'>{{subject.subject_name}}</p>
          <p class='item-team-time'>检录: <em>{{subject.check_time}}</em>
            检录2: <em>{{subject.check_time2}}</em>
            <span v-if="subject.check_time3 != '00:00:00'">检录3: <em>{{subject.check_time3}}</em></span>
            比赛: <em>{{subject.sai_time}}</em>
          (预计时间)
          </p>
        </van-step>

      </van-steps>
    </div>


  </div>


</template>
<style scoped>
  /* @import '../../assets/style/index.css'; */
  .item-team-desc{
    /*height:16.5px;*/
    font-size:12px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(102,102,102,0.85);
    line-height:24px;
    margin-bottom: 10px;
  }
  .item-team-time{
    font-size:12px;
    color:rgba(102,102,102,0.85);
  }
  .item-team-time em{
    font-size:14px;
    color:#000
  }
  .item-team-name{

    /* height:20px; */
    font-size:14px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(0,0,0,0.85);
    line-height:20px;
  }
  .item-team-name em{
    font-size: 18px;
    font-weight: bold;
  }
  .step-box{width:7.1rem;
    background:rgba(255,255,255,1);
    border-radius:7px;margin:17px auto;}

  .dropdown-item{padding-left: 1rem;margin-top: 5px;padding: 0 0 5px 1rem;border-bottom: 1px solid #f5f5f5;}
  .dropdown-item-title{
    height:20px;
    font-size:14px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(0,0,0,1);
    line-height:20px;}
  .dropdown-item-time{
    height:20px;
    font-size:14px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:20px;}
  .top-box >>> [class*=van-hairline]::after{border: none;}
  .top-box{
    height: 2.21rem;width: 100%;background: #fff;padding-bottom: 16px;border-radius: 0 0 10px 10px;
    position: fixed;
    top: 0;
    z-index: 10;
  }
  .title{
    width:100%;
    font-size:19px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(0,0,0,1);
    line-height:26px;
    text-align: center;
    margin:10px 0 20px ;
  }
  .box {
    background: #F8F8F8;
    margin-bottom: 50px;
    height: 100%;
    /* overflow: hidden; */
  }



</style>

<script>
  import Vue from 'vue';
  import { DropdownMenu, DropdownItem,Step, Steps } from 'vant';

  Vue.use(DropdownMenu).use(DropdownItem).use(Step).use(Steps);

  export default {
    name: 'CompetitionOrder',
    components: {

    },
    data: function () {
      return {
        keywords:'',
        active: 1,
        value: 1,
        value2:2,
        optionSelectedIndex:0,
        switch1: false,
        switch2: false,
        options: [
        ],
        option2: [
          { text: '第一场', time: '14:00~15:00' ,value:0},
          { text: '第二场', time: '15:00~16:00' ,value:1},
          { text: '第三场', time: '16:00~17:00' ,value:2},
        ],
        params:{
            saiqu:0,
            start_id:0,
        },
        row:{

        },
        list:[]
      }
    },
    filter: {},
    mounted() {
      document.title = '出场顺序';
      this.params.saiqu = this.$route.query.saiqu;

       this.fetch()
    },
    destroyed() {
    },
    methods: {

      fetch(){
        let that = this;
        that.$api.get('/api/sai/startlist', that.params, (res) => {
          that.list = res.data.list;
          that.list.map((item) =>{
            that.$set(item,'show',true);
          })
          that.row = res.data.row
          that.options = res.data.options
          that.params.start_id = res.data.start_id
        })
      },
      onSearch(val){
        console.log(val);
        let that =this;
        that.list.map((item) =>{
          that.$set(item,'show',false);
          if(item.mingcheng.indexOf(val.trim()) !=-1  ){
            that.$set(item,'show',true);
          }
        })

      },
      onConfirm() {
        this.$refs.item.toggle();
      },
      startIdChange(){
        this.fetch();
      },
      dropdownChange1(item){
        console.log('dropdownChange1',item);
        this.params.start_id = item.id;
      } ,
      dropdownChange2(item){
        this.value2=item.value

      }

    }
  }
</script>



// WEBPACK FOOTER //
// SaiStartList.vue?52cdf954